/*
 * @Descripttion:
 * @version:
 * @Author: AowCt <awoct10@163.com>
 * @Date: 2019-10-21 18:20:16
 * @LastEditors: AowCt <awoct10@163.com>
 * @LastEditTime: 2020-12-22 11:35:36
 */
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import "babel-polyfill"//解决ie空白问题

import VueRouter from 'vue-router'
//路由
import routes from './routes'
 
//默认样式
import './styles/reset.css'
//动画样式
import './styles/animate.css'
//主样式
import './styles/main.css'
//公共样式
import './styles/index.css'
//vuex
import store from './store'
// sessionStorage
import '@/js/sessionStorage'

//svg-icon
import '@/icons' // icon

import md5 from 'js-md5';

import axios from '@/api';
import {aseEncode,aseDecode} from '@/js/utils'


// 设置push重定向报错
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location, onResolve, onReject){
	// if( onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
	return originalPush.call(this, location).catch( err => err);
};
const originalReplace= VueRouter.prototype.replace;
VueRouter.prototype.replace = function replace(location, onResolve, onReject){
	// if( onResolve || onReject) return originalReplace.call(this, location, onResolve, onReject)
	return originalReplace.call(this, location).catch( err => err);
};

//md5加密
Vue.prototype.$md5 = md5
const router = new VueRouter({
  mode: 'history',
  routes
})

Vue.config.productionTip = false;
Vue.use(VueRouter)
Vue.use(ElementUI)

//获取cookie
const getCookie = (name) => {
	let arrCookie = document.cookie.split(";")
	for (let i = 0; i < arrCookie.length; i++) {
	  let arr = arrCookie[i].split("=") //从 = 的位置 分割每对cookie
	  if (arr[0].replace(/(^\s*|\s*$)/g, "") === name) { //存在此cookie
		return (arr[1] ? decodeURIComponent(arr[1]) : null) //若值不为空，返回此值，否则返回null
	  }
	}
	return null
  } 
  //设置cookie
  const setCookie = (name, val, time = 1 * 24 * 60 * 60 * 1000, path, domain) => {
	let exp = new Date(),
		p = path ? ';path=' + path : ';path=/',
		d = domain ? ';domain=' + domain : ''
	exp.setTime(exp.getTime() + time) //默认7天过期, 删除cookie传入负值即可
	document.cookie = name + "=" + encodeURIComponent(val) + ";expires=" + exp.toGMTString() + p + d
  }
  //获取cookie方法挂载于Vue 
  Vue.prototype.$getCookie = getCookie
  //设置cookie方法挂载于Vue 
  Vue.prototype.$setCookie = setCookie

//将ajax和请求地址url挂载于Vue
// Vue.prototype.$ajax = ajaxServer
//toast方法挂载于Vue
Vue.prototype.$toast = (msg, type = 'warning', time = 2000, showClose = false) => {
	Vue.prototype.$message({
		message: msg,
		type: type,
		duration: time,
		showClose: showClose
	})
}
// 挂载axios
Vue.prototype.$axios = axios;
//load方法挂载于Vue
/*
 * target: 需要覆盖的 DOM 节点   object/string
 * text: 显示在加载图标下方的加载文案
 * spinner: 自定义加载图标类名
 */
Vue.prototype.$load = {
 	instance: null,
 	loading(target = document.body, text = '', spinner = '') {
		this.instance = Vue.prototype.$loading({
			target,
			text,
			spinner
		})
	},
	loaded() {
		if (this.instance) this.instance.close()
		this.instance = null
	}
}

Vue.mixin({

})

//全局路有钩子
router.beforeEach(function (to, from, next) {
		let vuexStrorage = Vue.prototype.$getSessionStorage('vuex');
		vuexStrorage = vuexStrorage != null ? JSON.parse(vuexStrorage) : null;
		if (to.meta.indicator || document.querySelector("#content")) {//需要loading效果时
			Vue.prototype.$load.loading("#content")
		}
		// console.log(store.mutations);
		// store.dispatch('resetTab');//重置viewTabs
		if (!to.meta.noTab) {//将访问的页面推入
			let isHasTo = () => {
				for (let i = 0; i < store.state.viewTabs.length; i++) {
					const item = store.state.viewTabs[i]
					if (to.path === item.path) {
						return true
					}
				}
				return false
			}
			if (!isHasTo()) store.dispatch('pushTab', {"name": to.name[1] ? to.name[1] : to.name[0], "path": to.path})
		}
		if(to.path != '/login'){
			if(!Vue.prototype.$getSessionStorage('ticket') || Vue.prototype.$getSessionStorage('ticket') != md5(Vue.prototype.$getSessionStorage('username')+'ArteryFlow-AneuPlan')){//没有获取到ticket的情况
				Vue.prototype.$clearSessionStorage();
				next({
					path: '/login',
					query: {referrer: to.fullPath}
				});
				// next('/login');
			}else {// 获取到ticket的情况
				let bid = to.params.bid;
				let tableIdArr = Array.isArray(vuexStrorage.tableIdArr) ? [] : JSON.parse(aseDecode(vuexStrorage.tableIdArr,'AneuPlan-8847￥￥%ERF_)((^%4dkfj&45'));
				if(aseDecode(vuexStrorage.rolePermission, "AneuPlan-gygfuewifhertfeith56u489trf#%$&gvdfvjrty56&") == 'superAdministrator'){
					next();
				}else{
					if(bid && tableIdArr.find((p)=>{return p == bid}) == undefined){
						if(tableIdArr.find((p)=>{return p == bid}) == undefined){
							next({path:'/404'});
						}else{
							next();
						}
					}else{
						next();
					}
				}
			}
		}else{
			next();
			Vue.prototype.$clearSessionStorage();
		}
	
})
router.afterEach(function (to) {
	to.meta.routeList = {
		name: to.name,
		path: to.path
	}
	if (to.meta.indicator || document.querySelector("#content")) {//需要loading效果时
		setTimeout(function() {
	    	Vue.prototype.$load.loaded()
		}, 300)
	}
})
new Vue({
	el: '#app',
	router,
	store,
	components: { App },
	template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js